import React from 'react';
import { type PrivateIconProps } from './shared';
import { PortfolioWithLetterIcon } from './PortfolioWithLetterIcon';

export const PrivatePortfolioIcon = ({ color, className }: PrivateIconProps) => {
  return (
    <PortfolioWithLetterIcon dataTestId="qa-private-portfolio-icon" letter="p" className={className} color={color} />
  );
};
